const MediaItemDownloadInfoSize = {
  SMALL: "small",
  LARGE: "large",
  PRINT: "print",
  MLS: "mls",
  SD: "sd",
  HD: "hd",
  FHD: "1920x1080",
};

export default MediaItemDownloadInfoSize;
